import React from "react";
import { siteSettings } from "../../static";

const CloserCTA = () => {
  return (
    <section
      className="SectionSolution__SolutionSection-sc-1rwmdmt-0 joQNDL"
      style={{
        boxSizing: "border-box",
        WebkitTapHighlightColor: "transparent",
        margin: "0px",
        padding: "0px",
        border: "0px",
        font: "inherit",
        verticalAlign: "baseline",
        display: "block",
        animation: "20s ease 0s infinite normal none running solutionBg",
        background:
          'url("data:image/svg+xml;base64,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") 0px 0px repeat-x',
        paddingInlineStart: "9px",
        paddingRight: "9px",
        paddingTop: "140px",
      }}
    >
      <div
        className="Container-sc-rx245t-0 dGblwP"
        style={{
          boxSizing: "border-box",
          WebkitTapHighlightColor: "transparent",
          margin: "0px",
          padding: "0px",
          border: "0px",
          font: "inherit",
          verticalAlign: "baseline",
          marginInline: "auto",
          paddingInline: "10px",
          width: "100%",
          contain: "none",
          maxWidth: "1190px",
          paddingRight: "40px",
          paddingInlineStart: "40px",
        }}
      >
        <div
          className="SectionSolution__SolutionTitle-sc-1rwmdmt-1 hKlALu"
          style={{
            boxSizing: "border-box",
            WebkitTapHighlightColor: "transparent",
            margin: "0px",
            padding: "0px",
            border: "0px",
            font: "inherit",
            verticalAlign: "baseline",
            fontFamily: "Gilroy",
            fontWeight: 800,
            textAlign: "center",
            marginInline: "auto",
            maxWidth: "754px",
            fontSize: "44px",
            lineHeight: "54px",
            marginBottom: "30px",
          }}
        >
          Empower your trading efficiency with the market's most robust trading
          solutions
        </div>
        <a
          className="SectionSolution__SolutionBtn-sc-1rwmdmt-2 eFxRqr"
          href={`${siteSettings.appLink}/register`}
          style={{
            boxSizing: "border-box",
            WebkitTapHighlightColor: "transparent",
            margin: "0px",
            font: "inherit",
            transition:
              "color 0.15s ease-in-out 0s, background-color 0.15s ease-in-out 0s, border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s",
            border: "1px solid rgb(48, 113, 238)",
            padding: "0.375rem 0.75rem",
            marginInline: "auto",
            borderRadius: "6px",
            textDecoration: "none",
            textTransform: "uppercase",
            lineHeight: 1.5,
            backgroundClip: "padding-box",
            textAlign: "center",
            verticalAlign: "middle",
            display: "flex",
            WebkitBoxAlign: "center",
            alignItems: "center",
            WebkitBoxPack: "center",
            justifyContent: "center",
            width: "263px",
            height: "52px",
            fontSize: "1rem",
            fontWeight: 600,
            color: "rgb(255, 255, 255)",
            backgroundColor: "rgb(48, 113, 238)",
            cursor: "pointer",
          }}
        >
          START TRADING
        </a>
      </div>

      <br />
      <br />
    </section>
  );
};

export default CloserCTA;
